import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAccount, login } from './thunk';

interface LoginState {
  account: any;
  error: string;
  success: boolean;
  isUserLogout: boolean;
  token: string;
}

const initialState: LoginState = {
  account: null,
  error: '',
  token: '',
  success: false,
  isUserLogout: false,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginError(state: LoginState, action: PayloadAction<string | any>) {
      state.error = action.payload;
      state.success = false;
    },
    logoutSuccess(state: LoginState, action: PayloadAction<boolean>) {
      state.isUserLogout = action.payload;
    },
    logoutUser(state: LoginState) {
      state.token = '';
    },
    loginUser(state: LoginState, action: PayloadAction<string>) {
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state: any, action: any) => {
      state.token = action.payload.id_token;
    });
    builder.addCase(getAccount.fulfilled, (state: any, action: any) => {
      state.account = action.payload;
    });
  },
});

export const { loginError, logoutSuccess, logoutUser, loginUser } = loginSlice.actions;
export default loginSlice.reducer;
